import * as React from "react";
const SvgFiRrA = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-a_svg__a)">
      <path
        fill="#062147"
        d="m23.93 22.634-7.786-19.82c-1.288-3.718-7-3.717-8.288 0L.069 22.634a1 1 0 1 0 1.86.73l2.502-6.366h15.137l2.5 6.366a1 1 0 0 0 1.863-.73M5.218 14.999l4.5-11.454c.924-2.104 3.64-2.104 4.565 0L18.782 15z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-a_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrA;
